import React, {useEffect} from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const showCancelSuccess = () => {
  toast.error("Cancel successful", {
    position: toast.POSITION.TOP_LEFT,
    style: {
      backgroundColor: "#eb4335",
      width: "650px",
      color: "#FFFFFF",
      left: "500px",
      theme: "light",
    },
  });
};

let paramToChange;

const Cancel = ({ open, onClose }) => {
  // Scroll to top of page on mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const navigate = useNavigate();
  let path;
  if (!open) return null;

  if (window.location.href.includes("/ServiceRequest")) {
    paramToChange = "Service Request"
    path = "/ClientList"
  }
  else if (window.location.href.includes("/ClientPage")) {
    paramToChange = "Create Client"
    path = "/ClientList"
  }
  else if (window.location.href.includes("/EditClientPage")) {
    paramToChange = "Edit Client"
    path = "/ClientList";
    window.scrollTo(0,0);
  }
  else if(window.location.href.includes("/EditServiceRequest")) {
    paramToChange = "Edit Service Request"
    path = "/ServiceRequestList";
  }

  return (
    <div className="overlay">
      <ToastContainer newestOnTop={true} />
      <div className="overlayMain">
        <div className="modalContainer">
          <div className="content">
            {/* <h3>Cancel Service Request</h3> */}
            <h3>Cancel {paramToChange}</h3>
            <br></br>
            <p>Are you sure you want to cancel?</p>
          </div>
          <div className="btnContainer">
            <button
              className="btnPrimary"
              onClick={() => {
                showCancelSuccess();
                navigate(path, { state: { showToast: true } });
              }}
            >
              <span>YES</span>
            </button>
            <button className="btnSecondary" onClick={onClose}>
              NO
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cancel;
